import React from 'react';

export function InputLabelComponent ({ id, label, isRequired, className }: any) {
 
  const displayStar = '*';
  return label
    ? <label
    className={` ${className ? className : ' font-semibold line-clamp-2 mb-2 text-slate-800'}`}
            id={id}
      >
        {label}
 
        {isRequired
          ? <span style={{ color: 'red' }}>
              {' '}
              {displayStar}
            </span>
          : <></>}
    </label >
    : <></>
}
